import type { SupportedLocale } from "./index";

export const LOCALE_STORAGE_KEY = "duetto.locale";

/** Resolve the best supported locale from an ordered list of BCP-47 tags
 * (e.g. `navigator.languages`). First tag whose lowercased 2-letter prefix
 * is in `supported` wins; falls back to `"en"`. Pure — no DOM, no i18next —
 * so the platform branch that calls it stays isolated in `initI18n`. */
export function resolveDeviceLocale(
  languages: readonly string[],
  supported: readonly SupportedLocale[],
): SupportedLocale {
  for (const tag of languages) {
    const prefix = tag.slice(0, 2).toLowerCase();
    const hit = supported.find((s) => s === prefix);
    if (hit) return hit;
  }
  return "en";
}
